import { render, staticRenderFns } from "./AlternativesDropdownMenu.vue?vue&type=template&id=18b9ddf6&scoped=true"
import script from "./AlternativesDropdownMenu.vue?vue&type=script&lang=js"
export * from "./AlternativesDropdownMenu.vue?vue&type=script&lang=js"
import style0 from "./AlternativesDropdownMenu.vue?vue&type=style&index=0&id=18b9ddf6&prod&lang=scss"
import style1 from "./AlternativesDropdownMenu.vue?vue&type=style&index=1&id=18b9ddf6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18b9ddf6",
  null
  
)

export default component.exports